module.exports = __webpack_public_path__ + "img/linkedin.4a665b71.png";